import { gql } from '@apollo/client/core';

export const FETCH_ONBOARDING_STATE = gql`
  query onboardingState {
    onboardingState {
      ... on CorporateOnboardingState {
        CorporateOnboardingState: value
      }
      ... on SitterOnboardingState {
        SitterOnboardingState: value
      }
    }
  }
`;

export const SITTER_PROFILE_QUERY = gql`
  query {
    sitterProfile {
      id
      babysitterProfileCompleted
      babysitterProfileVisible
      nannyProfileCompleted
      nannyProfileVisible
      petCareProfileCompleted
      petCareProfileVisible
      companionCareProfileCompleted
      companionCareProfileVisible
      housekeepingProfileCompleted
      housekeepingProfileVisible
      location {
        cityname
        stateabbr
      }
    }
  }
`;

export default SITTER_PROFILE_QUERY;
